export default {
  namespaced: true,
  state: () => ({
    enum: {

      // @const {Object} internalLinkName 內部連結名稱
      internalLinkName: {
        HOME: {
          ROOT: 'Home',
        },
        LOGIN: {
          ROOT: 'Login',
        },
        READER: {
          ROOT: 'Reader',
        },
        CUSTOMER: {
          ROOT: 'Customer',
          subNode: {
            VIEW: 'view',
            OUTLINE: 'outline',
          },
        },
      },
    },
  }),
  mutations: {
    UPDATE_NAVLIST_TYPE(state, navListYtpe) {
      state.enum.navListType = navListYtpe;
    },
  },
  actions: {
    updateNavListType({ commit }, navListType) {
      commit('UPDATE_NAVLIST_TYPE', navListType);
    },
  },
  getters: {
    getEnum(state) {
      return state.enum;
    },
    getNavListType(state) {
      return state.enum.navListType;
    },
  },
};
